'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

var _basicTextPage = require('./basic-text-page');

var _basicTextPage2 = _interopRequireDefault(_basicTextPage);

var _reactIntl = require('react-intl');

var _doctifyUtils = require('doctify-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var locale = 'en';

var _locale$split = locale.split('-'),
    localeBase = _locale$split[0];

var lang = require('react-intl/locale-data/' + localeBase);
var messages = void 0;
try {
	messages = require('../lang/' + localeBase + '.json');
} catch (error) {
	messages = require('../../src/lang/en.json');
}
(0, _reactIntl.addLocaleData)(lang);

var PatientFaqs = function PatientFaqs() {
	return _react2.default.createElement(
		_reactIntl.IntlProvider,
		{ locale: localeBase, messages: messages },
		_react2.default.createElement(
			_basicTextPage2.default,
			{
				pageTitle: 'Patient FAQs | Doctify',
				pageDescription: 'Frequently asked questions for patients on doctify.',
				pagePath: (0, _doctifyUtils.getResourcePath)('/patient-faqs')
			},
			_react2.default.createElement(
				'h1',
				null,
				'FAQs (patients)'
			),
			_react2.default.createElement(
				'h2',
				null,
				'How do I know which doctor is right for me?'
			),
			_react2.default.createElement(
				'p',
				null,
				'We believe that finding the right doctor should be easy. This is why we focus so much on giving you the tools to do this. You can start your search by typing or entering the ',
				_react2.default.createElement(
					'a',
					{ href: 'https://www.doctify.co.uk/information/specialties' },
					'specialty'
				),
				', ',
				_react2.default.createElement(
					'a',
					{ href: 'https://www.doctify.co.uk/information/conditions' },
					' condition'
				),
				',',
				_react2.default.createElement(
					'a',
					{ href: 'https://www.doctify.co.uk/information/procedures' },
					'procedure'
				),
				',',
				_react2.default.createElement(
					'a',
					{ href: 'https://www.doctify.co.uk/search' },
					'specialist'
				),
				', ',
				_react2.default.createElement(
					'a',
					{ href: 'https://www.doctify.co.uk/search?healthCheck=all&sort=relevance&page=1' },
					'clinic'
				),
				', or ',
				_react2.default.createElement(
					'a',
					{ href: 'https://www.doctify.co.uk/search?scan=all&sort=relevance&page=1' },
					'scan'
				),
				' that you would like to  find information on. On the following search results page, you can set your preferences to order your results based on what matters most to you. Filter by location, review score, health insurer or language to order the results and find the right doctor, dentist or health specialist for you. Opening a specialist profile page allows you to see what ',
				_react2.default.createElement(
					'a',
					{ href: 'https://www.doctify.co.uk/information/conditions' },
					' conditions'
				),
				' and ',
				_react2.default.createElement(
					'a',
					{ href: 'https://www.doctify.co.uk/information/procedures' },
					'procedures'
				),
				' that doctor specialises in and where they studied. All of this will help you make the most informed decision possible. You can also help others by leaving your own review after seeing one of our doctors.'
			),
			_react2.default.createElement(
				'h2',
				null,
				'How do I book an appointment?'
			),
			_react2.default.createElement(
				'p',
				null,
				'Once you have found the doctor, dentist or health specialist that you want to see, follow these simple steps:'
			),
			_react2.default.createElement(
				'ol',
				null,
				_react2.default.createElement(
					'li',
					null,
					'Check out their availability by looking at the calendar on their profile page'
				),
				_react2.default.createElement(
					'li',
					null,
					'Select the date and time when you want to book an appointment'
				),
				_react2.default.createElement(
					'li',
					null,
					'Let the doctor know whether you have private health insurance or whether you will self-pay'
				),
				_react2.default.createElement(
					'li',
					null,
					'If you don\u2019t have an account with Doctify you will be prompted to sign-up',
					_react2.default.createElement(
						'a',
						{ href: 'https://www.doctify.co.uk/login' },
						'  here'
					)
				),
				_react2.default.createElement(
					'li',
					null,
					'Finally, briefly let the doctor know the reason for your visit and leave your mobile number'
				)
			),
			_react2.default.createElement(
				'p',
				null,
				'If you are signed in, the whole process can take less than 60 seconds. You will receive a confirmation email with instructions on how to prepare for your appointment and an email with a link to your Doctify ',
				_react2.default.createElement(
					'a',
					{ href: 'https://www.doctify.co.uk/login' },
					'Dashboard'
				),
				' where you will find details of your appointment.'
			),
			_react2.default.createElement(
				'h2',
				null,
				'What if the doctor has no availability?'
			),
			_react2.default.createElement(
				'p',
				null,
				'If the doctor has no availability or you don\u2019t find the time that you are looking for, you can also request an appointment. Follow these simple steps:'
			),
			_react2.default.createElement(
				'ol',
				null,
				_react2.default.createElement(
					'li',
					null,
					'Click \u201CRequest Appointment\u201D'
				),
				_react2.default.createElement(
					'li',
					null,
					'If you don\u2019t have an account with Doctify, you will be prompted to fill in your personal details and to state the reason for your visit'
				),
				_react2.default.createElement(
					'li',
					null,
					'Click \u201Csubmit\u201D. You will receive a confirmation email with instructions on how to prepare for your appointment and an email with a link to your Doctify ',
					_react2.default.createElement(
						'a',
						{ href: 'https://www.doctify.co.uk/login' },
						'Dashboard'
					),
					' (if you have set up an account) where you will find details of your appointment'
				)
			),
			_react2.default.createElement(
				'p',
				null,
				'In almost every case, our doctors will usually call or email you within 24-48 hours to offer you a time for your appointment. If you do not hear back from them, please call us on +44 20 3411 0652 or email us at ',
				_react2.default.createElement(
					'a',
					{ href: 'mailto:hello@doctify.co.uk' },
					'hello@doctify.co.uk'
				),
				'.'
			),
			_react2.default.createElement(
				'h2',
				null,
				'Can I filter consultations by price?'
			),
			_react2.default.createElement(
				'p',
				null,
				'Not at the moment. We are actively working on bringing you that feature.'
			),
			_react2.default.createElement(
				'h2',
				null,
				'How can I cancel an appointment?'
			),
			_react2.default.createElement(
				'p',
				null,
				'To cancel an upcoming appointment follow these simple steps:'
			),
			_react2.default.createElement(
				'ol',
				null,
				_react2.default.createElement(
					'li',
					null,
					'Log in to your Doctify ',
					_react2.default.createElement(
						'a',
						{ href: 'https://www.doctify.co.uk/login' },
						'Dashboard'
					)
				),
				_react2.default.createElement(
					'li',
					null,
					'Select the appointment you want to cancel and hit \u201Ccancel\u201D'
				)
			),
			_react2.default.createElement(
				'p',
				null,
				'We know that things can change quickly but please try and give our specialists as much time as possible when cancelling an appointment.'
			),
			_react2.default.createElement(
				'h2',
				null,
				'Why can\u2019t I see my review?'
			),
			_react2.default.createElement(
				'p',
				null,
				'We take our patient review system very seriously. We have a zero-tolerance policy towards false or misleading reviews. For this reason, we read every review that comes through before posting it. We do this to make sure that our reviews are useful for future patients, whether they are positive or negative.'
			),
			_react2.default.createElement(
				'h2',
				null,
				'Why do you want to know my location?'
			),
			_react2.default.createElement(
				'p',
				null,
				'This helps us show you doctors and health specialists near you which in turn helps you to find appointments as conveniently as possible.'
			),
			_react2.default.createElement(
				'h2',
				null,
				'Why do I get emails with health articles?'
			),
			_react2.default.createElement(
				'p',
				null,
				'As our network of doctors and health specialists has grown, we have been able to collect really valuable health tips and advice from them. We publish this content on our blog: the ',
				_react2.default.createElement(
					'a',
					{ href: 'https://www.doctify.co.uk/blog' },
					'Doctify Journal'
				),
				'. We believe that getting trustworthy information on these matters is very important which is why we curate the best content for you each month, for free. We also understand if you don\u2019t want to receive this information so you can always unsubscribe from this list (don\u2019t worry, this won\u2019t affect the notifications you receive from your Doctify account).'
			),
			_react2.default.createElement(
				'h2',
				null,
				'Is Doctify an alternative to the NHS?'
			),
			_react2.default.createElement(
				'p',
				null,
				'The NHS is a public service available which provides free medical care (in almost all cases) to people living in the United Kingdom. Specialists, treatments and practices listed on Doctify provide private medical care which will either be covered by your private medical insurance (always check with your insurer) or where you will have to pay yourself (self-pay). You can always mix and match NHS services and private care.'
			),
			_react2.default.createElement(
				'h2',
				null,
				'Why can I not see when some doctors are available?'
			),
			_react2.default.createElement(
				'p',
				null,
				'Doctors need to update their calendars with their availability and when they are free. In some cases they may be very busy. In other cases they may have forgotten to upload availability. However, in any case you can request an appointment with that doctor and they will typically contact you within 24-48 hours to confirm when they can see you.'
			),
			_react2.default.createElement(
				'h2',
				null,
				'Can I make an appointment for a relative?'
			),
			_react2.default.createElement(
				'p',
				null,
				'Yes, book or request an appointment as though you were doing it for yourself and then specify whom the appointment will be for in the \u2018reason for visit\u2019 box.'
			),
			_react2.default.createElement(
				'h2',
				null,
				'I have not received an email confirmation, what should I do?'
			),
			_react2.default.createElement(
				'p',
				null,
				'Sometimes emails take a few minutes to arrive in your inbox. It may also be that the email has gone into your junk folder. All appointment bookings and requests can always be found on your Doctify  ',
				_react2.default.createElement(
					'a',
					{ href: 'https://www.doctify.co.uk/login' },
					'Dashboard'
				),
				'.'
			),
			_react2.default.createElement(
				'h2',
				null,
				'Are you a health specialist?'
			),
			_react2.default.createElement(
				'p',
				null,
				'FAQs for health specialists are ',
				_react2.default.createElement(
					'a',
					{ href: 'http://help.doctify.co.uk/specialist-faq-s' },
					'here'
				),
				'.'
			),
			_react2.default.createElement(
				'h2',
				null,
				'Didn\u2019t find what you were looking for?'
			),
			_react2.default.createElement(
				'p',
				null,
				'If there is anything we can help with, we will do our best to support you. Your questions are so important to us.'
			),
			_react2.default.createElement(
				'p',
				null,
				'Call us at +44 20 3411 0652',
				_react2.default.createElement('br', null),
				'Email us at ',
				_react2.default.createElement(
					'a',
					{ href: 'mailto: hello@doctify.co.uk' },
					' hello@doctify.co.uk'
				),
				_react2.default.createElement('br', null),
				'Tweet us ',
				_react2.default.createElement(
					'a',
					{ href: 'https://www.twitter.com/doctifyuk' },
					'@doctifyuk '
				),
				_react2.default.createElement('br', null)
			),
			_react2.default.createElement(
				'p',
				null,
				'You can also ',
				_react2.default.createElement(
					'a',
					{ href: 'https://www.doctify.co.uk/social-media' },
					'follow or contact us'
				),
				' through social media.'
			),
			_react2.default.createElement(
				'div',
				{ className: _style2.default.socialMediaHolder },
				_react2.default.createElement(
					'a',
					{ href: 'https://www.facebook.com/doctifyuk', target: '_blank', className: '-facebook', title: 'Like your find a doctor specialists on Facebook' },
					_react2.default.createElement('i', { className: "ion-social-facebook" })
				),
				_react2.default.createElement(
					'a',
					{ href: 'https://twitter.com/doctifyuk', target: '_blank', className: '-twitter', title: 'Tweet your find a doctor specialists on Twitter' },
					_react2.default.createElement('i', { className: 'ion-social-twitter' })
				),
				_react2.default.createElement(
					'a',
					{ href: 'https://www.linkedin.com/company/doctify', target: '_blank', className: '-linkedin', title: 'Share your find a doctor specialists on LinkedIn' },
					_react2.default.createElement('i', { className: 'ion-social-linkedin' })
				),
				_react2.default.createElement(
					'a',
					{ href: 'https://instagram.com/doctify/', target: '_blank', className: '-instagram', title: 'Share your find a doctor specialists on Instagram' },
					_react2.default.createElement('i', { className: 'ion-social-instagram-outline' })
				),
				_react2.default.createElement(
					'a',
					{ href: 'https://plus.google.com/u/0/111311986530482578105/posts/', target: '_blank', className: '-googleplus', title: 'Plus one us on Google Plus' },
					_react2.default.createElement('i', { className: 'ion-social-googleplus-outline' })
				),
				_react2.default.createElement(
					'a',
					{ href: '/blog', target: '_blank', className: '-blog', title: 'Read our latest blog posts' },
					_react2.default.createElement('i', { className: 'ion-chatbubble' })
				)
			)
		)
	);
};

PatientFaqs.displayName = 'PatientFaqs';

PatientFaqs.defaultProps = {};

exports.default = PatientFaqs;


// WEBPACK FOOTER //
// ./components/info-page/lib/components/patient-faqs-page.js